import { ListagemPadrao } from "../../padronizado/listagem-padrao";
import { EmpresaInterface } from "../../../types/EmpresaInteface";

export const Empresa: React.FC = () => {
  // Definição das colunas da tabela
  const colunas: {
    titulo: string;
    campo: keyof EmpresaInterface;
    alinhamento?: 'start' | 'center' | 'end';
  }[] = [
    { titulo: "ID Empresa", campo: "id_empresa" },
    { titulo: "CNPJ", campo: "cnpj" },
    { titulo: "Inscrição Estadual", campo: "ie" },
    { titulo: "Razão Social", campo: "razao_social" },
    { titulo: "Nome Fantasia", campo: "fantasia" },
    { titulo: "Cidade", campo: "cidade" },
    { titulo: "Estado", campo: "uf" },
  ];

  // Campos que serão utilizados na pesquisa
  const camposPesquisa: (keyof EmpresaInterface)[] = [
    "razao_social",
    "fantasia",
    "cnpj",
    "cidade"
  ];

  // Função para personalizar a mensagem de confirmação de exclusão
  const mensagemConfirmacaoExclusao = (empresa: EmpresaInterface) => {
    return `Tem certeza que deseja excluir a empresa \n ${empresa.razao_social}?`;
  };

  return (
    <ListagemPadrao<EmpresaInterface>
      titulo="Empresas"
      endpoint="/empresas"
      colunas={colunas}
      campoId="id_empresa"
      rotaBase="/cadastro/empresa"
      camposPesquisa={camposPesquisa}
      usaPaginacaoServidor={false}
      mensagemConfirmacaoExclusao={mensagemConfirmacaoExclusao}
    />
  );
}; 